import { navigateTo } from '../app/nav.ts';
import { pickFile } from '../app/projectActions.ts';
import { createProjectFromPhoto } from '../photo/create.ts';
import { PHOTO_ERROR } from '../photo/import.ts';
import { ask, errorMessage, toast } from '../state/feedback.ts';
import { settingsData, useSettings } from '../state/settingsStore.ts';
import { requestPersistence } from '../storage/index.ts';

export const hasCamera = () => typeof matchMedia === 'function' && matchMedia('(pointer: coarse)').matches;

/** Creates a project from a photo file and opens it in the editor. */
export async function startFromFile(file: File): Promise<void> {
  try {
    const project = await createProjectFromPhoto(file, settingsData(useSettings.getState()));
    void requestPersistence();
    await navigateTo({ to: '/p/$projectId/edit', params: { projectId: project.id } });
  } catch (e) {
    toast(errorMessage(e, PHOTO_ERROR), 'error');
  }
}

export async function pickAndStart(source: 'library' | 'camera'): Promise<void> {
  const file = await pickFile('image/*', source === 'camera' ? 'environment' : undefined);
  if (file) await startFromFile(file);
}

/** "New Project": straight to the picker on desktop; Choose / Take Photo on touch devices. */
export async function newProjectFlow(): Promise<void> {
  if (!hasCamera()) return pickAndStart('library');
  const choice = await ask({
    title: 'New Project',
    message: 'Start from a photo of the front of a house.',
    actions: [
      { label: 'Choose Photo', value: 'library' as const, variant: 'primary' },
      { label: 'Take Photo', value: 'camera' as const, variant: 'secondary' },
      { label: 'Cancel', value: null, variant: 'ghost' },
    ],
  });
  if (choice) await pickAndStart(choice);
}
